<div class="entities-editor-wrapper">
  <div class="editor-header">
    <div class="header-title">
      {{ 'REFERENCES.EDITOR.ENTITIES' | translate }}
    </div>
    <div class="header-actions">
      <button class="add-btn" (click)="addEntity()" [title]="'REFERENCES.ADD_ENTITY' | translate">
        <fa-icon [icon]="icons.faPlus"></fa-icon>
        <span>{{ 'REFERENCES.ADD_ENTITY' | translate }}</span>
      </button>
      <button class="add-btn" (click)="addObject()" [title]="'REFERENCES.ADD_OBJECT' | translate">
        <fa-icon [icon]="icons.faPlus"></fa-icon>
        <span>{{ 'REFERENCES.ADD_OBJECT' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="entities-editor-list">
    @for (obj of objects; track $index; let i = $index) {
    <div class="object-item">
      <div class="object-header">
        <input class="label-input" [(ngModel)]="obj.relation" (ngModelChange)="onContentChanged()"
          [placeholder]="'REFERENCES.RELATION_PLACEHOLDER' | translate" />

        @if (getObjOccurrenceData(obj, i).total > 1) {
        <span class="occurrence-badge">
          {{ getObjOccurrenceData(obj, i).index }}/{{ getObjOccurrenceData(obj, i).total }}
        </span>
        }

        <div class="obj-actions">
          <button class="add-val-btn" (click)="addObjectKey(obj)" [title]="'REFERENCES.ADD_KEY' | translate">
            <fa-icon [icon]="icons.faPlus"></fa-icon>
          </button>
          <button class="delete-btn" (click)="deleteObject($index)" [title]="'BUTTON.DELETE' | translate">
            <fa-icon [icon]="icons.faTrash"></fa-icon>
          </button>
        </div>
      </div>

      <div class="object-keys">
        @for (key of getObjectKeys(obj.values); track key) {
        <div class="entity-item-standalone editor nested">
          <div class="label-wrapper">
            <input class="label-input mini" [ngModel]="key" (ngModelChange)="updateObjectKey(obj, key, $event)"
              [placeholder]="'REFERENCES.KEY_PLACEHOLDER' | translate" />
          </div>

          <input class="val-input" [(ngModel)]="obj.values[key][0].text" (ngModelChange)="onContentChanged()"
            [placeholder]="'REFERENCES.VALUE_PLACEHOLDER' | translate" />

          <button class="delete-btn" (click)="deleteObjectKey(obj, key)" [title]="'BUTTON.DELETE' | translate">
            <fa-icon [icon]="icons.faTrash"></fa-icon>
          </button>
        </div>
        }
      </div>
    </div>
    }

    @for (entity of entities; track entity.id; let i = $index) {
    <div class="entity-item-standalone editor">
      <div class="label-wrapper">
        <input class="label-input mini" [(ngModel)]="entity.label" (ngModelChange)="onContentChanged()"
          [placeholder]="'REFERENCES.LABEL_PLACEHOLDER' | translate" />

        @if (getOccurrenceData(entity).total > 1) {
        <span class="occurrence-badge mini">
          {{ getOccurrenceData(entity).index }}/{{ getOccurrenceData(entity).total }}
        </span>
        }
      </div>
      <input class="val-input" [(ngModel)]="entity.text" (ngModelChange)="onContentChanged()"
        [placeholder]="'REFERENCES.VALUE_PLACEHOLDER' | translate" />
      <button class="delete-btn" (click)="deleteEntity($index)" [title]="'BUTTON.DELETE' | translate">
        <fa-icon [icon]="icons.faTrash"></fa-icon>
      </button>
    </div>
    }
  </div>
</div>